module.exports = __webpack_public_path__ + "media/scan.2dd11f83.webm";